import React from "react";
import { useLoading } from "./LoadingContext";
import logo from './ll.png'
export default function Loading() {
  const { showLoading } = useLoading();
  return (
    <>
      {showLoading && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-100 z-50">
      <div className="relative">
        
        <img src={logo} alt="Logo" className="w-24 h-24 rounded-full animate-spin" />
      </div>
    </div>
      )}
    </>
  );
}
